import React, { useContext } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  BASE_URL,
  multiSelectStyle,
  userRole,
  userRole2,
} from "../../../constant";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";

const UserForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { authCtx, darkMode } = useContext(AppContext);
  const defaultform = {
    name: "",
    userName: "",
    password: "",
    emailId: "",
    mobileNumber: "",
    teams: [],
    role: null,
    active: true,
    company: null,
    companyId: null,
    companyAssign: false,
    acknowledgeAlarm: false,
    confirmAlarm: false,
    singleSignOn: false,
  };

  const [teams, setTeams] = useState([]);
  const [user, setUser] = useState(defaultform);
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate();

  const onValueChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleRoleChange = (event, id) => {
    setUser({
      ...user,
      role: event.value.id,
      userRole: event.value,
    });
  };

  const handleCompanyChange = (event, id) => {
    setUser({
      ...user,
      company: event.value,
      companyId: event.value.id,
      companyName: event.value.name,
    });
  };

  const onSubmit = async (e) => {
    if (
      user.name === "" ||
      user.userName === "" ||
      user.password === "" ||
      (user.role !== 100 && user.companyId === null)
    ) {
      toast.error("All fields must be filled");
    } else {
      // Check if the entered value is a valid email address
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(user.emailId)) {
        toast.error("Please enter a valid email address");
        return;
      }
      setLoading(true);
      const payload = { ...user, teamsIds: user.teams.join(",") };
      try {
        if (!user.id) {
          const res = await axios.post(`${BASE_URL}/UserMaster`, payload);
          setUser({ ...user, id: res.data });
        } else {
          if (user.role === 100) user.companyId = null;
          const res = await axios.put(`${BASE_URL}/UserMaster`, payload);
        }
        toast.success("Successfully Saved User");
        setLoading(false);
      } catch (err) {
        if (err.response?.status === 400) toast.error(err.response.data);
        else toast.error("An error occured");
        setLoading(false);
      }
    }
  };

  const generatePassword = () => {
    var generatedPassword = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*_+";

    for (var i = 0; i < 6; i++) {
      generatedPassword += possible.charAt(
        Math.floor(Math.random() * possible.length)
      );
    }
    setUser({ ...user, password: generatedPassword });
  };

  const handlePropertyOptionChange = (event, action) => {
    setUser({
      ...user,
      teams: event.map((x) => x.value),
    });
  };

  const onCheckBox = (e) => {
    setUser((pre) => ({
      ...pre,
      [e.target.name]: e.target.checked,
    }));
  };

  const onCloseClick = (e) => {
    navigate(`/userlist`);
  };

  const loadData = async (companyData) => {
    let userData = { ...user };
    if (id !== "new") {
      let res = await axios.get(`${BASE_URL}/UserMaster/getUserById?id=${id}`);
      const data = res.data;
      userData = {
        ...data,
        company: companyData.find((x) => x.id === data.companyId),
        userRole: userRole.find((u) => u.id === data.role),
        teams: res.data.teamsIds ? res.data.teamsIds.split(",") : [],
      };
    } else {
      const company = companyData.find(
        (x) => x.id === authCtx.profile.companyId
      );
      if (company)
        userData = {
          ...user,
          companyId: company.id,
          company: company,
          companyName: company.name,
        };
    }
    setUser(userData);
    loadTeams(userData);
  };

  const loadLookupData = async () => {
    let res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      const data = res.data;
      setCompanies(data);
      return data;
    }
  };

  const loadTeams = async (userData) => {
    const companyId =
      userData.role === 100 ? "~All" : authCtx.profile.companyId;
    const res = await axios.get(
      `${BASE_URL}/api/TeamMaster?companyId=${companyId}`
    );
    if (res.status === 200) {
      const data = res.data;
      setTeams(
        data.map((x) => ({
          value: x.id,
          label: x.name,
          companyId: x.companyId,
        }))
      );
    }
  };

  useEffect(() => {
    const loadDatas = async () => {
      const companyData = await loadLookupData();
      loadData(companyData);
    };
    loadDatas();
  }, []);

  return (
    <div className="flex flex-col relative text-white px-14 py-7 dark:bg-darkModeBg bg-lightModeBg h-full">
      <div className="flex text-xs lg:text-sm font-medium gap-3 items-center">
        <label className="dark:text-white text-labels">
          {user.id
            ? `${t("masters.fields.editUser")} : ${user.userName}`
            : t("masters.fields.addUser")}
        </label>
        <div className="flex h-10 w-10  dark:bg-neutral-800 bg-gray2 justify-center items-center rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke={darkMode ? "white" : "black"}
            class="w-4 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
            />
          </svg>
        </div>
      </div>
      <div className="w-fit">
        <div className="flex gap-2">
          <div
            className={`${
              user.id ? "grid-cols-2 gap-x-3" : "grid-cols-3 gap-x-2"
            } grid w-fit`}
          >
            {/* <div className="flex flex-row text-xs font-medium py-4 gap-3"> */}
            <div className="flex flex-col w-fit text-xs lg:text-sm">
              <label className="dark:text-white text-labels font-medium py-2">
                {t("masters.fields.name")}
                <span className=" text-red-600 ml-1">*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="Enter Name"
                value={user.name}
                onChange={onValueChange}
                className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5  w-40 lg:w-80 h-9"
              />
            </div>
            {user.id ? null : (
              <div className="flex col-span-2 gap-2 w-fit">
                <div className="flex flex-col ml-1 text-xs lg:text-sm">
                  <label className="dark:text-white text-labels font-medium py-2">
                    {t("masters.fields.username")}
                    <span className=" text-red-600 ml-1">*</span>
                  </label>
                  <input
                    type="text"
                    name="userName"
                    placeholder="Enter Username"
                    value={user.userName}
                    onChange={onValueChange}
                    className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5  w-40 lg:w-80 h-9"
                  />
                </div>
                <div className="flex flex-col ml-1 text-xs lg:text-sm">
                  <label className="dark:text-white text-labels font-medium py-2">
                    {t("masters.fields.password")}
                    <span className=" text-red-600 ml-1">*</span>
                  </label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      name="password"
                      placeholder="Enter Password"
                      value={user.password}
                      onChange={onValueChange}
                      className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5  w-40 lg:w-80 h-9"
                      disabled
                    />
                    {/* <div>
                  {user.id ? null : (
                    <button
                      type="button"
                      onClick={generatePassword}
                      className=" bg-green-600 text-xs lg:text-sm rounded-lg w-28 h-9 items-center"
                    >
                      Generate
                    </button>
                  )}
                </div> */}
                  </div>
                </div>
              </div>
            )}
            {/* </div> */}
            {/* <div className="flex text-xs font-medium  py-4 gap-3"> */}
            <div className="flex flex-col w-fit text-xs lg:text-sm">
              <label className="dark:text-white text-labels font-medium py-2">
                {t("masters.fields.email")}
                <span className=" text-red-600 ml-1">*</span>
              </label>
              <input
                type="email"
                name="emailId"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                placeholder="Enter Email"
                value={user.emailId}
                onChange={onValueChange}
                className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5  w-40 lg:w-80 h-9"
              />
            </div>
            <div
              className={`${
                !user.id && "ml-1"
              } flex flex-col w-fit text-xs lg:text-sm`}
            >
              <label className="dark:text-white text-labels font-medium py-2">
                {t("masters.fields.no")}
                <span className=" text-red-600 ml-1">*</span>
              </label>
              <input
                type="text"
                name="mobileNumber"
                placeholder="Enter Mobile Number"
                value={user.mobileNumber}
                onChange={onValueChange}
                className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5  w-40 lg:w-80 h-9"
              />
            </div>
            <div
              className={`${
                !user.id && "ml-1"
              } flex flex-col  w-40 lg:w-80 ml-1 text-xs lg:text-sm`}
              id="userrolecompo"
            >
              <label className="dark:text-white text-labels font-medium py-2">
                {t("masters.fields.role")}
                <span className=" text-red-600 ml-1">*</span>
              </label>
              <div className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
                <ComboBox
                  data={userRole2}
                  name="role"
                  dataItemKey="id"
                  textField="name"
                  placeholder="User Role"
                  clearButton={false}
                  className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-gray-700 rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5  h-9"
                  onChange={handleRoleChange}
                  value={user.userRole}
                />
              </div>
            </div>
            {user.role !== 100 && authCtx.profile.role === 100 ? (
              <div
                className={`${
                  !user.id && "ml-1"
                } flex flex-col  w-40 lg:w-80 ml-1 text-xs lg:text-sm`}
                id="userrolecompo"
              >
                <label className="dark:text-white text-labels font-medium py-2">
                  {t("masters.fields.company")}
                  <span className=" text-red-600 ml-1">*</span>
                </label>
                <div className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
                  <ComboBox
                    data={companies}
                    name="role"
                    dataItemKey="id"
                    textField="name"
                    placeholder="Select a company"
                    clearButton={false}
                    className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-gray-700 rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5  h-9"
                    onChange={handleCompanyChange}
                    value={user.company}
                  />
                </div>
              </div>
            ) : null}
            <div className="flex flex-col text-xs lg:text-sm">
              <label className="dark:text-white text-labels font-medium py-2">
                {t("masters.fields.teams")}
                <span className=" text-red-600 ml-1">*</span>
              </label>
              <div
                className={`w-80 max-w-full min-h-9 ${
                  darkMode ? "darkCreatableSelect" : "lightCreatableSelect"
                }`}
              >
                <CreatableSelect
                  isMulti
                  {...multiSelectStyle}
                  options={teams}
                  getOptionLabel={(option) =>
                    user.role === 100
                      ? `${option.label} ( ${
                          companies.find((x) => x.id === option.companyId)?.name
                        } )`
                      : `${option.label}`
                  }
                  name="options"
                  value={teams.filter((x) => user.teams.includes(x.value))}
                  onChange={(e, action) =>
                    handlePropertyOptionChange(e, action)
                  }
                />
              </div>
            </div>
            <div className="flex mt-4 ml-2 items-center h-full gap-10">
              <p className="text-sm font-medium dark:text-white text-labels">
                {t("masters.fields.sso")}:
              </p>
              <SwitchComponent
                onLabel="ON"
                offLabel="OFF"
                name="singleSignOn"
                checked={user.singleSignOn}
                onChange={onCheckBox}
              />
            </div>
          </div>
          <div className="mt-8 lg:mt-9">
            {user.id ? null : (
              <button
                type="button"
                onClick={generatePassword}
                className=" bg-green-600 text-xs lg:text-sm rounded-lg w-28 h-9  items-center"
              >
                {t("button.generate")}
              </button>
            )}
          </div>
        </div>
        <div className="flex items-center mt-7 gap-5 w-full justify-end pr-28">
          {user.role === 300 ? (
            <div className="flex gap-10 justify-center mr-10">
              <div className="flex items-center justify-between">
                <label className=" inline-block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts text-xs lg:text-sm dark:text-white text-labels mr-3 mt-1">
                  {t("masters.fields.acknowledgeAlrm")}
                </label>
                <input
                  name="acknowledgeAlarm"
                  type="checkbox"
                  className="focus:ring-blue-500 h-4 lg:h-5 w-4 lg:w-5 text-blue-600 border-gray-300 rounded mt-1"
                  id="inlineCheckbox1"
                  defaultChecked={true}
                  onChange={onCheckBox}
                  checked={user.acknowledgeAlarm}
                  value={user.acknowledgeAlarm}
                ></input>
              </div>
              <div className="flex items-center justify-between">
                <label className=" inline-block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts text-xs lg:text-sm dark:text-white text-labels mr-3 mt-1">
                  {t("masters.fields.confirmAlrm")}
                </label>
                <input
                  name="confirmAlarm"
                  type="checkbox"
                  className="focus:ring-blue-500 h-4 lg:h-5 w-4 lg:w-5 text-blue-600 border-gray-300 rounded mt-1"
                  id="inlineCheckbox1"
                  defaultChecked={true}
                  onChange={onCheckBox}
                  checked={user.confirmAlarm}
                  value={user.confirmAlarm}
                ></input>
              </div>
            </div>
          ) : null}
          <div className="flex justify-center form-check form-check-inline ">
            <label
              className="form-check-label inline-block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts text-xs lg:text-sm dark:text-white text-black mr-3 mt-1"
              forhtml="inlineCheckbox1"
            >
              {t("masters.fields.active")}
            </label>
            <input
              name="active"
              type="checkbox"
              className="focus:ring-blue-500 h-4 lg:h-5 w-4 lg:w-5 text-blue-600 border-gray-300 rounded mt-1"
              id="inlineCheckbox1"
              onChange={onCheckBox}
              checked={user.active}
              value={user.active}
            ></input>
          </div>
          <button
            type="button"
            onClick={onCloseClick}
            className=" dark:bg-white bg-closeBtns dark:text-black text-closeBtnTxts text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10"
          >
            {t("button.cancel")}
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={
              loading ||
              user.name === "" ||
              user.userName === "" ||
              user.password === "" ||
              user.emailId === "" ||
              user.mobileNumber === "" ||
              user.role === null ||
              (user.role !== 100 && user.companyId == null) ||
              user.teams.length === 0
            }
            className="dark:bg-indigo-700 bg-submitBtns dark:text-white text-submitBtnTxts disabled:opacity-40 text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10 flex justify-center items-center gap-3"
          >
            {loading && (
              <svg class="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            )}
            {user.id ? t("button.update") : t("button.create")}
          </button>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default UserForm;
